import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAPIURL } from "../../services/helper";
import http from "../../services/http";
import { Spinner, Container, Button } from "reactstrap";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import { openView } from "../../ReduxToolkit/Reducers/viewReducer";

const CloseReportDetails = ({ register_id }) => {
  // const { register_id } = useParams(); // Get register ID from URL
  const api_url = getAPIURL();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchRegisterReport();
  }, []);

  const fetchRegisterReport = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(
        `${api_url}/reports/close/detail/${register_id}`
      );
      setTransactions(data.transactions || []);
    } catch (error) {
      console.error("Error fetching register report:", error);
    }
    setLoading(false);
  };

  const columns = [
    { name: "Order ID", selector: (row) => row.order_id, sortable: true },
    { name: "Order Date", selector: (row) => row.order_date, sortable: true },
    {
      name: "Total",
      selector: (row) => `$${row.order_total}`,
      sortable: true,
    },
    {
      name: "Received",
      selector: (row) => `$${row.amount_paid}`,
      sortable: true,
    },
    {
      name: "Change Given",
      selector: (row) => `$${row.change_given}`,
      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => row.payment_type,
      sortable: true,
    },
    {
      name: "Tax Collected",
      selector: (row) => `$${row.tax_collected || 0}`,
      sortable: true,
    },
    {
      name: "Discounts",
      selector: (row) => `$${row.discount || 0}`,
      sortable: true,
    },
  ];

  return (
    <div className="page-body">
      <Container className="mt-5">
        {loading ? (
          <div className="text-center">
            <Spinner color="primary" size="lg" />
            <p>Loading Transactions...</p>
          </div>
        ) : transactions.length > 0 ? (
          <DataTable
            columns={columns}
            data={transactions}
            pagination
            striped
            highlightOnHover
          />
        ) : (
          <p className="text-center">No transactions found.</p>
        )}

        <Button
          color="primary"
          className="mt-4"
          onClick={() => dispatch(openView("reports_close"))}
        >
          Back
        </Button>
      </Container>
    </div>
  );
};

export default CloseReportDetails;
